import React, { useEffect, useRef, useState } from "react";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { addLocale, locale } from "primereact/api";
import { Button } from "primereact/button";
import { Calendar, CalendarChangeParams } from "primereact/calendar";
import { RequestMethod } from "utils/enums";
import AvailableTime from "./components/available-time";
import RegisterForm from "./components/form/RegisterForm";
import { IFormData, IFreeTimeslots, IUrgentAssistanceScheduler } from "./interfaces";
import './styles.css';

export default function ScheduleBooking(props: IUrgentAssistanceScheduler) {
    addLocale('en', {
        firstDayOfWeek: 1
    })
    locale('en');
    // @ts-ignore
    const urlEasas = props.customHost ? props.customHost : `${window.location.origin.toString() + window.contextRoot}`;
    const meetingEndpoint = '/rest/events/meetings'
    const urlFreeTimeslostEndpoint = `${meetingEndpoint}/freeTimeslots`;
    const urlBookMeetingEndpoint = `${meetingEndpoint}/bookMeeting`;

    const [freeTimeslots, setFreeTimeslots] = useState<IFreeTimeslots | undefined>(undefined);
    const [disabledDates, setDisabledDates] = useState<Date[] | undefined>(undefined);
    const [selectedDate, setSelectedDate] = useState<Date | Date[] | undefined>(undefined);
    const [selectedDateTimeSlots, setSelectedDateTimeSlots] = useState<Array<string> | undefined>(undefined);
    const [selecetedTime, setSelecetedTime] = useState<number | undefined>(undefined);
    const [selecetedDatetime, setSelecetedDatetime] = useState<string>('');
    const [timeConfirmed, setTimeConfirmed] = useState<boolean>(false); // time is selected, set true, and render form
    const [errorOccured, setErrorOcured] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [scheduling, setScheduling] = useState(false);

    /** 
    * Formats date to string with specific format: yyyy-mm-dd
    * @param Date date - date to format
    * @return string formated date
    */
    const formatDateToString = (date: Date[] | Date | undefined): string => {
        if (date instanceof Date) {
            return `${date.getFullYear()  }-${  (date.getMonth() + 1).toString().padStart(2, '0')  }-${  date.getDate().toString().padStart(2, '0')}`;
        }
        return '';
    }

    interface IResponseObj {
        valid: boolean;
        obj: object;
        errorMessage: string;
    }

    const sendRequest = async (endpoint: string, requestMethod: RequestMethod, body: any | undefined) => {
        const tempUrl = new URL(urlEasas + endpoint);
        // TODO paimti linkId query parametra is dabartinio url ir prideti ji siunciant requesta, klausimas ar man jo isvis reikia???
        // @ts-ignore
        // let params: URLSearchParams = new URL(document.location).searchParams;
        const params: URLSearchParams = new URL(document.location).searchParams;

        const linkId = params.get('linkId'); // TODO test if exception ocurs

        if (!linkId) {
            easasAlert({ summary: "ERROR", detail: "Query param {linkId} not found", severity: "error", life: 50000 });
            const ojb: IResponseObj = {
                valid: false,
                errorMessage: 'Query param {linkId} not found',
                obj: {}
            }
            return ojb;
        }
        tempUrl.searchParams.append('linkId', linkId);

        const header: Headers = new Headers({
            'Content-Type': 'application/json'
        });
        if (props.token) {
            header.append('Authorization', `Bearer ${  props.token}`);
        }
        const requestInit: RequestInit = {
            method: requestMethod,
            headers: header,
        };
        if (!props.customHost) {
            requestInit.credentials = "same-origin";
        }
        if (body) {
            requestInit.body = JSON.stringify(body);
        }
        return fetch(tempUrl.href, requestInit)
            .then(async (response) => {
                const responseText = await response.text();
                let responseBody = {};
                try {
                    responseBody = JSON.parse(responseText);
                } catch (err) {
                    responseBody = {};
                }
                if (Object.keys(responseBody).length === 0) {
                    // E.g. status, return not ok, but has response statusText
                    // Object is empyt, throw error(return response status)
                    var obj: IResponseObj = {
                        valid: false,
                        errorMessage: response.statusText,
                        obj: responseBody
                    }
                    return obj
                } 
                    // Check response status code, if ok, return parsed obj, show error
                    if (!response.ok) {
                        var obj: IResponseObj = {
                            valid: false,
                            // @ts-ignore TODO may throw error
                            errorMessage: responseBody.message,
                            obj: responseBody
                        }
                    } else {
                        var obj: IResponseObj = {
                            valid: true,
                            // @ts-ignore TODO may throw error
                            errorMessage: '',
                            obj: responseBody
                        }
                    }
                    return obj
                
            })
            .catch(function (err) {
                console.log(`Error while Fetching data from server, error:${  err.message}`);
                const obj: IResponseObj = {
                    valid: false,
                    errorMessage: err.message,
                    obj: {}
                }
                return obj;
            });
    }

    const disableUnavailableDays = (obj: IFreeTimeslots | undefined) => {
        const date = new Date(); // month starts from 0, so before add to array, icrement
        const year = date.getFullYear();
        date.setDate(1);
        date.setMonth(0);
        date.setFullYear(year - 1);
        const allDays = [];
        while (date.getFullYear() === year - 1 || date.getFullYear() === year || date.getFullYear() === year + 1) {
            const d = `${date.getFullYear()  }-${  (date.getMonth() + 1).toString().padStart(2, '0')  }-${  date.getDate().toString().padStart(2, '0')}`;
            allDays.push(d);
            date.setDate(date.getDate() + 1);
        }
        const tempDisabledDates: any = [];
        allDays.forEach(element => {
            const newDate = new Date(element);
            try {
                // @ts-ignore
                const available = element in obj.timeSlots;
                if (!available) {
                    tempDisabledDates.push(newDate);
                }
            } catch (err) {
                tempDisabledDates.push(newDate);
            }
        });
        setDisabledDates(tempDisabledDates);
    }

    const fetchFreeTimeslots = async () => {
        const response: IResponseObj = await sendRequest(urlFreeTimeslostEndpoint, RequestMethod.GET, undefined);
        // converting response FROM lT TO UTC, FROM UTC TO user local date
        if (response.valid) {
            // @ts-ignore
            setFreeTimeslots(response.obj);
            // @ts-ignore
            disableUnavailableDays(response.obj);
        } else {
            // @ts-ignore
            disableUnavailableDays(response.obj);
            easasAlert({ 
              summary: "Error",
              detail: "Error while fetching data from server",
              severity: "error",
              life: 10000,
            });
            setErrorOcured(!response.valid);
            setErrorMessage(response.errorMessage)
        }
    }

    useEffect(() => {
        fetchFreeTimeslots();
    }, [])

    function swap(arr: any, xp: number, yp: number) {
        const temp = arr[xp];
        arr[xp] = arr[yp];
        arr[yp] = temp;
    }

    const sortTimeSlots = (slots: Array<string>) => {
        let i; let j;
        for (i = 0; i < slots.length; i++) {
            for (j = 0; j < slots.length - i - 1; j++) {
                if (slots[j] > slots[j + 1]) {
                    swap(slots, j, j + 1);
                }
            }
        }
        return slots;
    }
    // Handlers
    const handleDateSelect = (e: CalendarChangeParams) => {
        // TODO handle all variables(set to undefined if date changed???)
        setSelectedDate(e.value as Date);
        setSelecetedTime(undefined); // index of available time
        setTimeConfirmed(false);
        if (freeTimeslots) {
            const key = formatDateToString(e.value as Date);
            // @ts-ignore
            const date: Date = e.value;
            console.log(`Date selected:${  date.toISOString()}`);
            // @ts-ignore
            const dateFrom = date.toISOString();
            // @ts-ignore
            const dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString();

            const availableTimeSlots: Array<string> = [];
            const allTimeSlots: Array<string> = [];
            for (const [key, value] of Object.entries(freeTimeslots.timeSlots)) {
                value.forEach((val: string, i: number) => {
                    allTimeSlots.push(val);
                })
            }
            allTimeSlots.forEach((val, i) => {
                if (new Date(dateFrom) <= new Date(val) && new Date(dateTo) > new Date(val)) {
                    availableTimeSlots.push(val);
                }
            })

            const sortedAvailableTimeSlots = sortTimeSlots(availableTimeSlots);


            setSelectedDateTimeSlots(sortedAvailableTimeSlots);
        }
    }

    const handleTimeSelected = (index: number) => {
        console.log("Time selected");
        setSelecetedTime(index);
    }

    const handleConfirm = (timeStamp: string) => {
        setTimeConfirmed(true);
        setSelecetedDatetime(timeStamp);
    }

    const handleConfimCancelDateSelect = () => {
        setSelecetedTime(undefined);
        setSelectedDate(undefined);
        setTimeConfirmed(false);
    }

    const handleConfimCancel = () => {
        setSelecetedTime(undefined);
        setTimeConfirmed(false);
    }

    const handleScheduleEvent = async (data: IFormData) => {
        // TODO if date is shown as local time convert selected date to UTC
        console.log(`Date sending to schedule:${  data.timeSlot}`);
        setScheduling(true)
        const response = await sendRequest(urlBookMeetingEndpoint, RequestMethod.POST, data);
        if (response) {
            easasAlert({
              summary: "Success",
              detail: "Event scheduled successfuly",
              severity: "success",
              life: 10000,
            });
            handleConfimCancelDateSelect();
            disableUnavailableDays(undefined);
            fetchFreeTimeslots();
        } else {
            easasAlert({
              summary: "Error",
              detail: "Booking event error",
              severity: "error",
              life: 10000,
            });
            setErrorOcured(true);
        }
        setScheduling(false);
    }

    const mainDivRef = useRef(null);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(isMobileFunction(600))
    }, [])

    const isMobileFunction = (specifiedWidth: number) => {
        // @ts-ignore
        if (mainDivRef && mainDivRef.current && mainDivRef.current.offsetWidth) {
            // @ts-ignore
            const width = mainDivRef.current.offsetWidth;
            return width < specifiedWidth;
        }
        return false;
    }

    // TODO On select, show beautiful transition between calendar and available times
    // TODO If month has no free times, show it(add button to load other month)
    return (
      <div className="card" style={{ background: "white" }}>
        <div style={{ textAlign: "center" }}>
          <h5 style={{ fontSize: "30px" }}>Schedule your meeting</h5>
        </div>
        {Intl.DateTimeFormat().resolvedOptions().timeZone ? (
          <>
            {!errorOccured ? (
              <>
                {!timeConfirmed ? (
                  <div
                    ref={mainDivRef}
                    className={isMobile ? "" : "p-d-flex"}
                    style={{
                      maxWidth: isMobile ? "350px" : "720px",
                      height: "auto",
                      margin: "0 auto",
                      padding: "10px",
                      position: "relative",
                      background: "white",
                    }}
                  >
                    <div
                      style={{
                        minWidth: "300px",
                        height: "auto",
                        margin: "0 auto",
                        padding: "10px",
                        position: "relative",
                      }}
                      className="p-d-flex"
                    >
                      <div>
                        <Calendar
                          value={selectedDate}
                          onChange={e => handleDateSelect(e)}
                          inline
                          disabledDates={disabledDates}
                        />
                        {selectedDate && (
                          <div>
                            <Button
                              label="Cancel"
                              onClick={() => {
                                handleConfimCancelDateSelect();
                              }}
                              className="p-button-danger p-button-text"
                              style={{ margin: "10px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {selectedDate && selectedDateTimeSlots && (
                      <div
                        style={{
                          width: "40%",
                          minWidth: "274px",
                          maxWidth: "300px",
                          height: "auto",
                          margin: "0 auto",
                          padding: "10px",
                          position: "relative",
                        }}
                      >
                        {selectedDateTimeSlots.map((val, index) => {
                          return (
                            <AvailableTime
                              key={index}
                              timeStamp={val}
                              onTimeSelect={handleTimeSelected}
                              onTimeConfirm={handleConfirm}
                              selected={index === selecetedTime}
                              index={index}
                            />
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  <RegisterForm
                    selectedDateTime={selecetedDatetime}
                    onScheduleEvent={handleScheduleEvent}
                    handleConfimCancel={handleConfimCancel}
                    isMobile={isMobile}
                    scheduling={scheduling}
                  />
                )}
              </>
            ) : (
              <>{errorMessage && <ErrorDiv text={errorMessage || "Error"} />}</>
            )}
          </>
        ) : (
          <ErrorDiv text="Sorry, your browser is not supported" />
        )}
      </div>
    );
}

interface IErrorDiv {
    text: string;
}

function ErrorDiv(props: IErrorDiv) {
    return <div style={{ margin: 'auto', width: '50%', padding: '10px' }}>
        <div className="demo-container p-p-4" style={{ border: '2px solid #3C76DA', borderRadius: '25px' }}>
            <h3 className="p-d-block p-mx-auto" style={{ textAlign: 'center' }}>
                {props.text}
            </h3>
        </div>
    </div>
}